// ---------------------------------------------------------------------------
// ESPELHO da régua do ICP — Conservação Predial.
//
// ⚠️ ESTE ARQUIVO É CÓPIA DELIBERADA de `server/manutencao/conservacao/conserv-icp-utils.js`.
//    O front é Create React App e NÃO importa de `server/`, então a régua que
//    desenha a prévia ao vivo tem de existir duas vezes. **Mudou aqui, muda lá
//    — e vice-versa.** Há teste travando o par (`server/tests/espelhos-back-front.test.js`),
//    porque divergir não dá erro em lugar nenhum: a tela mostra uma nota e o
//    servidor grava outra, os dois calados.
//
// ⚠️ AUTOCONTIDO DE PROPÓSITO: sem `import`, sem `export default`. O teste de
//    espelho carrega este arquivo dentro do Jest do backend removendo os
//    `export` — se ele passar a importar algo, o teste FALHA dizendo isso, em
//    vez de comparar contra o vazio e passar verde escondendo a divergência.
//
// ⚠️ QUEM MANDA É O SERVIDOR. Isto é só a prévia enquanto o especialista
//    preenche; o backend recalcula e é ele quem grava.
//
// A RÉGUA (binária, desde 2026-09-09 — antes era Conforme 2 / Desgaste 1 /
// Intervenção 0, com cortes em 95/90/80/70):
//
//    ICP = itens SEM achado ÷ itens que contam
//
// Todo achado é uma pendência; não há meia pendência. O porquê, com os números
// medidos nas duas inspeções reais, está no cabeçalho do motor do servidor.
// ---------------------------------------------------------------------------

// A resposta é um ACHADO (pendência registrada)?
//
// ⚠️ ESCRITA NA FORMA POSITIVA, igual à do servidor: na forma negativa ("tudo
//    que não é Conforme"), 'N/A' e 'Fora do escopo' virariam pendência e a
//    prévia despencaria por item que ninguém olhou.
export const ehAchado = (status) => {
  const k = String(status ?? '').trim().toLowerCase();
  if (k === 'n/a' || k === 'na') return false;
  if (k === 'fora do escopo' || k === 'fora de escopo') return false;
  return k !== 'conforme';
};

// Faixa do ICP. ⚠️ Cortes recalibrados em 2026-09-09 junto com a régua: sem o
// meio ponto do Desgaste toda nota desceu ~12 a 24 pontos, e nos cortes antigos
// uma loja cujo pior problema é pintura apareceria como reprovada.
export const classificarIcp = (icp) => {
  if (icp >= 90) return 'Excelente';
  if (icp >= 80) return 'Muito Bom';
  if (icp >= 65) return 'Bom';
  if (icp >= 50) return 'Regular';
  return 'Necessita Intervenção';
};
